import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const COMPARISON = [{
  feature: 'Formulas',
  excel: 'Complex syntax, nested IFs, VLOOKUPs',
  s2b: 'Natural language prompts'
}, {
  feature: 'Dashboards',
  excel: 'Manual chart creation, static layouts',
  s2b: 'Instant, responsive boards'
}, {
  feature: 'Data Cleaning',
  excel: 'Tedious manual formatting, regex',
  s2b: 'One-click AI agents'
}, {
  feature: 'Integrations',
  excel: 'CSV exports, clunky plugins',
  s2b: 'Native Postgres, Stripe, API sync'
}, {
  feature: 'Collaboration',
  excel: 'File locking, version conflicts',
  s2b: 'Real-time multiplayer, branching'
}];
export function Compare() {
  return <section id="compare" className="py-24 border-t border-white/5 relative overflow-hidden" data-id="element-12">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-emerald-500/5 blur-[120px] pointer-events-none" data-id="element-13" />

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-14">
        <div className="text-center mb-16" data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4" data-id="element-16">
            Excel vs Sheets2Board
          </h2>
          <p className="text-zinc-400" data-id="element-17">
            Why modern teams are making the switch.
          </p>
        </div>

        <div className="border border-white/10 rounded-2xl overflow-hidden bg-zinc-900/20 backdrop-blur-sm" data-id="element-18">
          <div className="grid grid-cols-3 border-b border-white/10 bg-zinc-900/50" data-id="element-19">
            <div className="p-4 md:p-6 font-medium text-zinc-400" data-id="element-20">
              Capability
            </div>
            <div className="p-4 md:p-6 font-medium text-zinc-500 flex items-center gap-2" data-id="element-21">
              <div className="w-2 h-2 rounded-full bg-red-500/50" data-id="element-22" /> Traditional
              Excel
            </div>
            <div className="p-4 md:p-6 font-medium text-white flex items-center gap-2" data-id="element-23">
              <div className="w-2 h-2 rounded-full bg-emerald-500" data-id="element-24" />{' '}
              Sheets2Board
            </div>
          </div>

          <div className="divide-y divide-white/5" data-id="element-25">
            {COMPARISON.map((row, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} className="grid grid-cols-3 hover:bg-white/[0.02] transition-colors" data-id="element-26">
                <div className="p-4 md:p-6 text-sm font-medium text-zinc-300 flex items-center" data-id="element-27">
                  {row.feature}
                </div>
                <div className="p-4 md:p-6 text-sm text-zinc-500 flex items-start gap-3" data-id="element-28">
                  <X size={16} className="text-red-500/50 shrink-0 mt-0.5" data-id="element-29" />
                  {row.excel}
                </div>
                <div className="p-4 md:p-6 text-sm text-zinc-300 flex items-start gap-3" data-id="element-30">
                  <Check size={16} className="text-emerald-500 shrink-0 mt-0.5" data-id="element-31" />
                  {row.s2b}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}